import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const UpAndDownIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "UpAndDownIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M18 8.01528C18 7.84828 17.9364 7.68128 17.8092 7.55381L12.4604 2.19252C12.206 1.93756 11.794 1.93756 11.5396 2.19252L6.19077 7.55381C5.93641 7.80877 5.93641 8.22179 6.19077 8.47675C6.44514 8.73171 6.85721 8.73171 7.11157 8.47675L12 3.57693L16.8884 8.47675C17.1428 8.73171 17.5549 8.73171 17.8092 8.47675C17.9364 8.34928 18 8.18227 18 8.01528Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18 15.9847C18 16.1517 17.9364 16.3187 17.8092 16.4462L12.4604 21.8075C12.206 22.0624 11.794 22.0624 11.5396 21.8075L6.19077 16.4462C5.93641 16.1912 5.93641 15.7782 6.19077 15.5232C6.44514 15.2683 6.85721 15.2683 7.11157 15.5232L12 20.4231L16.8884 15.5232C17.1428 15.2683 17.5549 15.2683 17.8092 15.5232C17.9364 15.6507 18 15.8177 18 15.9847Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default UpAndDownIcon;
